import React, { SVGProps } from "react";

const RefreshOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7673 5.10008C11.2036 4.36775 10.4386 3.81562 9.56597 3.51123C8.69336 3.20684 7.75094 3.1634 6.85402 3.38621C5.95711 3.60903 5.14458 4.08844 4.51585 4.7658C3.88713 5.44315 3.46946 6.28908 3.31396 7.20008M12.0006 2.66675V5.33342H9.33396M4.23263 10.9001C4.79622 11.6327 5.56117 12.1851 6.43386 12.4897C7.30655 12.7942 8.2491 12.8378 9.14615 12.6149C10.0432 12.3921 10.8558 11.9125 11.4845 11.235C12.1132 10.5574 12.5307 9.71126 12.686 8.80008M3.99996 13.3334V10.6667H6.66663"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default RefreshOutline;
